export default defineNuxtPlugin(() => {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
  });
});
